// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1VPOC","form":"styles_form__1eVe1"};